import type { ReactNode } from 'react'
import { cx } from './cx'
import type { Tone } from './Pill'
import s from './Badge.module.css'

/**
 * Badge — a micro-label (counts, "DEFAULT", "NEW"). Smaller and louder than a
 * Pill: Pill states a status, Badge annotates. Shares the tone vocabulary.
 */
export function Badge({ tone = 'neutral', children, className, 'data-testid': testId }: {
  tone?: Tone
  children: ReactNode
  className?: string
  /**
   * Forwarded, because it was silently DROPPED before.
   *
   * A caller wrote `<Badge data-testid="...">`, TypeScript accepted it, and the
   * attribute never reached the DOM -- so the badge was unaddressable and the
   * test that looked for it failed as though the badge were missing. A shared
   * control that quietly discards what it is handed sends the next person
   * hunting in their own code.
   */
  'data-testid'?: string
}) {
  return <span className={cx(s.badge, s[tone], className)} data-testid={testId}>{children}</span>
}
